module.exports = __webpack_public_path__ + "static/img/faq-reply-button-icon-active.7f6978d7.svg";